import React from "react";
import { NavLink } from "react-router-dom";
import Access from "../../../components/Access";
import Icon from "../../../components/Icon";

const NavLinks = ( a_class ) =>
{
	let props = {};
	if ( a_class )
	{
		props["className"] = a_class;
	}
	
	return <ul key={"mainNav"} {...props}>
		<li><NavLink to="/">
			<Icon key={"home-icon"} iconName={"home"}/>
			<span key={"landingpage-text"}>Startseite</span>
		</NavLink></li>
		<Access permissions={[ "get_users" ]}>
			<li><NavLink to="/benutzerverwaltung">
				<Icon key={"user-icon"} iconName={"user"}/>
				<span key={"user-text"}>Benutzerverwaltung</span>
			</NavLink></li>
		</Access>
		<Access permissions={[ "get_organizations", "get_faktura_organization", "get_faktura_organizations" ]}>
			<li><NavLink to="/organisationsverwaltung">
				<Icon key={"organization-icon"} iconName={"organization"}/>
				<span key={"organization-text"}>Organisationsverwaltung</span>
			</NavLink></li>
		</Access>
		<Access permissions={[ "get_roles", "get_permissions" ]}>
			<li><NavLink to="/berechtigungsverwaltung">
				<Icon key={"permission-icon"} iconName={"permission"}/>
				<span key={"permission-text"}>Berechtigungsverwaltung</span>
			</NavLink></li>
		</Access>
		<div className={"cleared"}/>
	</ul>;
	
}; // function NavLinks(...)

export default NavLinks;
